import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAppApi } from "@/App";
import { ExportButton } from "@components/Common/Button";
import { RenderForm } from "@components/Forms/Render";
import { ListingCard } from "@components/Pages";
import { NothingFilteredAlert } from "@components/Statistics";
import { money_fmt, url_reverse } from "@components/Utils";

export default function StatisticsSunduki({ gameId, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:game:statistics:sunduki", { game_id: gameId }));

    if (!apiData) return;

    const headerTools = apiData.object_list?.length > 0 && (
        <ExportButton size="sm" prms={{ "filter-stats_period": apiData.forms_data.filter.data.stats_period }} />
    );

    return (
        <ListingCard header={header} headerTools={headerTools} filterComponent={false}>
            <RenderForm prefix="filter" submitButtonText={t("Построить")} submitMethod="get" />

            {apiData.stats_summary?.length > 0 && (
                <div className="mt-3">
                    <div className="jumbotron p-3 mb-0">
                        <h4>{t("Итого за период")}:</h4>
                        <div>
                            {apiData.stats_summary.map((s, ind) => (
                                <div key={`stats_summary_${ind}`}>
                                    <strong>{s.currency}:</strong> {money_fmt(s.amount)} ({s.count})
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            <NothingFilteredAlert />

            {apiData.object_list?.length > 0 && (
                <Table hover responsive className="dmg-table mt-4">
                    <thead>
                        <tr>
                            <th>{t("Дата/время")}</th>
                            <th>{t("Название")}</th>
                            <th>{t("Сумма")}</th>
                            <th>{t("Валюта")}</th>
                            <th>{t("Страна")}</th>
                            <th>User ID</th>
                            <th>{t("ID транзакции")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {apiData.object_list?.map((obj) => {
                            return (
                                <tr key={obj.id}>
                                    <td>{obj.date_added}</td>
                                    <td>{obj.title}</td>
                                    <td>{obj.amount}</td>
                                    <td>{obj.currency}</td>
                                    <td>{obj.country}</td>
                                    <td>{obj.user_id}</td>
                                    <td>{obj.payment_id}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            )}
        </ListingCard>
    );
}
